import { KVResolutionQuality } from 'types'

const MAX_DIMENSION = 2880 // 1920 px * 1.5

export interface StreamResolution {
  width: number
  height: number
}

export function calculateStreamResolution(
  containerWidth: number,
  containerHeight: number,
  quality: KVResolutionQuality = KVResolutionQuality.High
): StreamResolution {
  const scaledWidth = containerWidth * quality
  const scaledHeight = containerHeight * quality

  const widthScale =
    scaledWidth > MAX_DIMENSION ? MAX_DIMENSION / scaledWidth : 1
  const heightScale =
    scaledHeight > MAX_DIMENSION ? MAX_DIMENSION / scaledHeight : 1
  const constraintScale = Math.max(widthScale, heightScale)

  return {
    width: Math.round(scaledWidth * constraintScale),
    height: Math.round(scaledHeight * constraintScale),
  }
}
